import { render, staticRenderFns } from "./SendToMailchimpBtn.vue?vue&type=template&id=5c8615e4&scoped=true&"
import script from "./SendToMailchimpBtn.vue?vue&type=script&lang=ts&"
export * from "./SendToMailchimpBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8615e4",
  null
  
)

export default component.exports